import classes from './PasswordForm.module.css';
import { useState, useRef } from 'react';
import zxcvbn from 'zxcvbn';

function PasswordForm(props) {
	const [pwStrengthClass, setPasswordStrength] = useState(classes.score0);
	const feedback = useRef();
	const inputPasswordConfirmation = useRef();


	//----------------------------------------------------------------------
	//               Show/Hide Password
	//----------------------------------------------------------------------
	function showPassword() {
		const theType = (props.pwRef.current.type === 'text') ? 'password' : 'text';
		props.pwRef.current.type = theType;
		inputPasswordConfirmation.current.type = theType;
	}

	//----------------------------------------------------------------------
	//             Check Password Strength
	//----------------------------------------------------------------------
	function checkPasswordStrength(event) {
		event.preventDefault();
		const thePassword = props.pwRef.current.value;
		const thePasswordConfirmation = inputPasswordConfirmation.current.value;
		const testedResult = zxcvbn(thePassword);
		const theWarning = testedResult.feedback.warning +'. ';
		var theSuggestions = '';
		if (testedResult.feedback.suggestions.length > 1) {
			theSuggestions = testedResult.feedback.suggestions.join('. ') + '. '; }
		const crackTime = testedResult.crack_times_display.offline_slow_hashing_1e4_per_second;
		const crackMsg = "Can be cracked in " + crackTime + '. ';
		var theScore = testedResult.score;
		var pwWarning = '';
		if (thePassword === thePasswordConfirmation) { pwWarning ='';}
		else {
			pwWarning= 'Passwords do not match';
			theScore = 0;
		}
		feedback.current.innerHTML =  theWarning + theSuggestions + crackMsg + pwWarning;
		setPasswordStrength(classes['score'+testedResult.score]);
		if (theScore > 2) { props.allowSubmit(true); }
		else { props.allowSubmit(false); }
	}



	return (
		<div className={classes.svgWrapper}>
			<div className={classes.instructions}>Your email address will be your userid. 
				The password you chose must be a "good" password.</div>
			
				<div onClick={props.abort} className={classes.closeBtn}>❌</div>

			<div className={pwStrengthClass} ref={feedback}> </div>

			<label className={classes.passLabel} htmlFor="password">Password:</label>
			<input 
				className={classes.passwordBox} 
				id="password" 
				type="password" 
				ref={props.pwRef} 
				onChange={checkPasswordStrength}
			/>
			<div></div>

			<label className={classes.passLabel} htmlFor="confirmPassword">Password:</label>
			<input 
				id="confirmPassword" 
				className={classes.passwordBox} 
				type="password" 
				ref={inputPasswordConfirmation} 
				onChange={checkPasswordStrength}
			/>
			<span className={classes.svg} onClick={showPassword}>
				<svg 
					viewBox="0 0 24 24" 
					fill="none" 
					stroke="currentColor" 
					strokeWidth="2" 
					strokeLinecap="round" 
					strokeLinejoin="round" 
					xmlns="http://www.w3.org/2000/svg" 
					aria-hidden="true"
				>
					<path 
						d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z">
					</path>
					<circle cx="12" cy="12" r="3"></circle>
				</svg>
			</span>
		</div>
	)
}

export default PasswordForm;